import { ApiUrl } from '@common/enums';
import { PricedProduct, ProductEstimateQuery } from '@common/models';

import { easyEstimatorApi } from '../easyEstimatorService';

const pricedProductsApi = easyEstimatorApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchProductsPrices: builder.query<PricedProduct[], { data?: ProductEstimateQuery }>({
            query: ({ data }) => ({
                url: ApiUrl.PRICES,
                method: 'POST',
                data,
            }),
        }),
    }),
});

export const { useFetchProductsPricesQuery, useLazyFetchProductsPricesQuery } = pricedProductsApi;
